import React from 'react'
// import previaje from '../../imagenes/checkout/payment-options/previaje.png'

const Reintegros = (props) => {

  return (
    <section className="sobre-pedraza condiciones-contratacion">

      <div className="container">
        <div className="row">
          <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div><img style={{width: '100%'}} src="https://pedraza.com.ar/assets/img/paquetes/bg/reservaFlexible.jpg" alt="Banner Previaje"/></div>
            <br />
            <h1>Reserva Flexible</h1>
            <hr />

            <h6>Compra flexible para todos nuestros paquetes</h6>
            <p>Si por disposici&oacute;n del gobierno nacional o por determinaciones de los gobiernos provinciales o de pa&iacute;ses de destino -en caso de viajes al exterior-,
no se pudiera realizar el viaje contratado en la fecha original del viaje, este podr&aacute; ser reprogramado con las mismas condiciones originales pactadas, respetándose temporada acorde a disponibilidad y diagramación de la empresa y características por usted inicialmente contratadas. En
caso de no acceder a la reprogramaci&oacute;n, el pasajero podr&aacute; optar por la devoluci&oacute;n de lo abonado, que ser&aacute; el resultante una vez descontados todos
los cargos impositivos y bancarios que correspondan o que las tarjetas de cr&eacute;dito impongan ya sea por intereses, cargos administrativos, seguros etc.</p>



          </article>
        </div>
      </div>
    </section>

  )
}

export default Reintegros



// WEBPACK FOOTER //
// ./src/components/Global/ReservaFlexible.js